webpackJsonp([81089696799905],{

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: 2em;\n\n  table {\n    color: ", ";\n    font-size: 0.9em;\n    font-weight: 400;\n    letter-spacing: 0px;\n    list-style: none;\n    margin-bottom: -0.55em;\n    margin-left: -0.15em;\n    padding: 0 !important;\n    text-transform: none;\n\n    & + h2 {\n      margin-top: 2em;\n    }\n  }\n\n  td {\n    line-height: 1.3em;\n    padding-bottom: 0.4em;\n    padding-right: 0.35em;\n    vertical-align: top;\n  }\n"], ["\n  margin-bottom: 2em;\n\n  table {\n    color: ", ";\n    font-size: 0.9em;\n    font-weight: 400;\n    letter-spacing: 0px;\n    list-style: none;\n    margin-bottom: -0.55em;\n    margin-left: -0.15em;\n    padding: 0 !important;\n    text-transform: none;\n\n    & + h2 {\n      margin-top: 2em;\n    }\n  }\n\n  td {\n    line-height: 1.3em;\n    padding-bottom: 0.4em;\n    padding-right: 0.35em;\n    vertical-align: top;\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colors = __webpack_require__(27);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _hoofdstukkenGrieks = __webpack_require__(225);
	
	var _hoofdstukkenGrieks2 = _interopRequireDefault(_hoofdstukkenGrieks);
	
	var _hoofdstukkenLatijn = __webpack_require__(226);
	
	var _hoofdstukkenLatijn2 = _interopRequireDefault(_hoofdstukkenLatijn);
	
	var _leerdoelenGrieks = __webpack_require__(193);
	
	var _leerdoelenGrieks2 = _interopRequireDefault(_leerdoelenGrieks);
	
	var _leerdoelenLatijn = __webpack_require__(194);
	
	var _leerdoelenLatijn2 = _interopRequireDefault(_leerdoelenLatijn);
	
	var _gatsbyLink = __webpack_require__(121);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject, _colors2.default.main);
	
	exports.default = function (_ref) {
	  var book = _ref.book,
	      chapter = _ref.chapter,
	      leerdoel = _ref.leerdoel,
	      type = _ref.type;
	
	  // where to get the leerdoelen/voorkennis per chapter from
	  var hoofdstukken = book == "spqr" ? _hoofdstukkenLatijn2.default : _hoofdstukkenGrieks2.default;
	
	  // where to get the formulation/voorkennis per leerdoel from
	  var leerdoelen = book == "spqr" ? _leerdoelenLatijn2.default : _leerdoelenGrieks2.default;
	
	  // what specific leerdoel codes to render
	  var codes = type == undefined ? leerdoelen[leerdoel]["voorkennis"] : hoofdstukken[chapter - 1][type];
	
	  // what h2 to render
	  var heading = function heading(type) {
	    switch (type) {
	      case "leerdoelen":
	        return "wat moet ik nu kunnen?";
	      case "voorkennis":
	        return "wat moet ik kunnen voordat ik begin?";
	      default:
	        return "voorkennis";
	    }
	  };
	
	  var leerdoelDesc = function leerdoelDesc(code) {
	    return leerdoelen[code].description;
	  };
	
	  return _react2.default.createElement(
	    "div",
	    null,
	    codes.length < 1 ? null : _react2.default.createElement(
	      Container,
	      null,
	      _react2.default.createElement(
	        "h2",
	        null,
	        heading(type)
	      ),
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          codes.map(function (code) {
	            return _react2.default.createElement(
	              "tr",
	              { key: code },
	              _react2.default.createElement(
	                "td",
	                null,
	                code + ". "
	              ),
	              leerdoelen[code].pageExists ? _react2.default.createElement(
	                "td",
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: "/" + book + "/leerdoelen/" + code },
	                  leerdoelDesc(code)
	                )
	              ) : _react2.default.createElement(
	                "td",
	                null,
	                leerdoelDesc(code)
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 640:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  margin-bottom: 1.9rem;\n"], ["\n  margin-bottom: 1.9rem;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _leerdoelenGrieks = __webpack_require__(193);
	
	var _leerdoelenGrieks2 = _interopRequireDefault(_leerdoelenGrieks);
	
	var _leerdoelenLatijn = __webpack_require__(194);
	
	var _leerdoelenLatijn2 = _interopRequireDefault(_leerdoelenLatijn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	exports.default = function (_ref) {
	  var book = _ref.book,
	      leerdoel = _ref.leerdoel;
	
	  var leerdoelenList = book == "spqr" ? _leerdoelenLatijn2.default : _leerdoelenGrieks2.default;
	  var leerdoelDesc = leerdoelenList[leerdoel].description;
	
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      "h2",
	      null,
	      "Leerdoel"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      leerdoelDesc
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	  leerdoelen: ["1a", "1b"],
	  voorkennis: []
	}, {
	  leerdoelen: ["2a"],
	  voorkennis: ["1a"]
	}];
	module.exports = exports["default"];

/***/ }),

/***/ 226:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = [{
	  leerdoelen: ["1a", "1b", "1c", "1d", "1e", "1f", "1g", "1h", "1i", "1j", "1k", "1l", "1m", "1n", "1o", "1p", "1q", "1r", "1s", "1t"],
	  voorkennis: []
	}, {
	  leerdoelen: ["2a", "2b", "2c", "2d", "2e", "2f", "2g", "2h", "2i"],
	  voorkennis: ["1q", "1r"]
	}, {
	  leerdoelen: ["3a", "3b", "3c", "3d", "3e", "3f", "3g", "3h"],
	  voorkennis: ["1q", "1r"]
	}, { leerdoelen: ["4a", "4b", "4c", "4d", "4e"], voorkennis: ["1q", "1r"] }, { leerdoelen: ["5a", "5b", "5c", "5d"], voorkennis: [] }, { leerdoelen: ["6a", "6b", "6c", "6d", "6e"], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["8a", "8b", "8c", "8d", "8e", "8f", "8g"],
	  voorkennis: ["1a", "1d"]
	}, {
	  leerdoelen: ["9a", "9b", "9c", "9d", "9e", "9f", "9g", "9h"],
	  voorkennis: []
	}, {
	  leerdoelen: ["10a", "10b", "10c", "10d", "10e", "10f", "10g", "10h", "10i", "10j", "10k"],
	  voorkennis: ["8a", "8b"]
	}, { leerdoelen: ["11a", "11b", "11c", "11d"], voorkennis: ["8a"] }, {
	  leerdoelen: ["12a", "12b", "12c", "12d", "12e", "12f"],
	  voorkennis: ["8b", "8d", "10e"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["15a", "15b", "15c", "15d", "15e", "15f"],
	  voorkennis: ["5a", "5b", "5c"]
	}, {
	  leerdoelen: ["16a", "16b", "16c", "16d"],
	  voorkennis: ["5a", "5b", "5c", "15a", "15c"]
	}, { leerdoelen: ["17a", "17b"], voorkennis: ["3a", "16a", "16b"] }, {
	  leerdoelen: ["18a", "18b", "18c", "18d", "18e", "18f", "18g", "18h", "18i", "18j"],
	  voorkennis: ["16a"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["22a", "22b", "22c", "22d", "22e", "22f"],
	  voorkennis: ["5c", "1m", "1n", "2c", "3d", "4c"]
	}, { leerdoelen: ["23a", "23b", "23c", "23d", "23e", "23f"], voorkennis: [] }, {
	  leerdoelen: ["24a", "24b", "24c", "24d", "24e", "24f", "24g"],
	  voorkennis: ["22e", "22f"]
	}, {
	  leerdoelen: ["25a", "25b", "25c", "25d", "25e", "25f", "25g"],
	  voorkennis: ["1e"]
	}, {
	  leerdoelen: ["26a", "26b", "26c", "26d"],
	  voorkennis: ["10k", "25b", "25c", "25d", "25f", "25g"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["29a", "29b", "29c", "29d", "29e", "29f", "29g", "29h", "29i"],
	  voorkennis: ["8a", "8b", "8d", "10e", "12c"]
	}, {
	  leerdoelen: ["30a", "30b", "30c", "30d", "30e"],
	  voorkennis: ["29a", "8b", "8d", "10e", "10f", "29c"]
	}, {
	  leerdoelen: ["31a", "31b", "31c", "31d", "31e"],
	  voorkennis: ["29a", "8b", "9a", "9b", "15e"]
	}, {
	  leerdoelen: ["32a", "32b", "32c", "32d", "32e", "32f"],
	  voorkennis: ["8a", "10f", "29c", "10g", "11b", "31c", "31d"]
	}, {
	  leerdoelen: ["33a", "33b", "33c", "33d", "33e", "33f", "33g", "33h", "33i"],
	  voorkennis: ["25b", "25c", "25d", "25e", "26c", "26d", "8b", "10k", "31a"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["36a", "36b", "36c", "36d", "36e"],
	  voorkennis: ["5a", "5b", "15a", "5c", "5d"]
	}, {
	  leerdoelen: ["37a", "37b", "37c", "37d", "37e"],
	  voorkennis: ["15c", "16c", "16d", "17a", "22b"]
	}, {
	  leerdoelen: ["38a", "38b", "38c", "38d", "38e", "38f"],
	  voorkennis: ["8b", "16c", "16d"]
	}, {
	  leerdoelen: ["39a", "39b", "39c"],
	  voorkennis: ["31a", "15e", "16d", "25e"]
	}, {
	  leerdoelen: ["40a", "40b", "40c", "40d", "40e", "40f", "40g", "40h", "40i", "40j", "40k"],
	  voorkennis: ["15e", "22b"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["43a", "43b", "43c", "43d", "43e", "43f", "43g"],
	  voorkennis: ["8a", "30b", "8b", "10e"]
	}, {
	  leerdoelen: ["44a", "44b", "44c", "44d", "44e", "44f", "44g", "44h", "44i", "44j", "44k", "44m"],
	  voorkennis: ["8a", "30b", "8b", "12c", "31a", "10e", "43d", "43e", "6d"]
	}, {
	  leerdoelen: ["45a", "45b", "45c", "45d", "45e", "45f", "45g"],
	  voorkennis: ["44c"]
	}, { leerdoelen: ["46a", "46b", "46c", "46d", "46e"], voorkennis: ["22b"] }, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["50a", "50b", "50c", "50d", "50e"],
	  voorkennis: ["30b", "8b", "31a", "10f", "29c", "43d", "43e"]
	}, {
	  leerdoelen: ["51a", "51b"],
	  voorkennis: ["38a", "38b", "31a", "31b", "38e", "39a", "38f", "39a", "39b"]
	}, {
	  leerdoelen: ["52a", "52b", "52c", "52d"],
	  voorkennis: ["38a", "38b", "31a", "31b", "38e", "39a", "38f", "39a", "51a", "51b"]
	}, { leerdoelen: [], voorkennis: [] }, {
	  leerdoelen: ["54a", "54b", "54c", "54d", "54e", "54f", "54g", "54h", "54i", "54j"],
	  voorkennis: ["8b", "44f", "44g", "22b"]
	}, { leerdoelen: [], voorkennis: [] }, { leerdoelen: [], voorkennis: [] }];
	module.exports = exports["default"];

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  "1a": {
	    description: "Grapje!",
	    pageExists: true
	  },
	  "1b": {
	    description: "Geinig toch?",
	    pageExists: false
	  },
	  "2a": {
	    description: "Nog een poging!",
	    pageExists: false
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = {
	  "1a": {
	    description: "Ik kan uitleggen wat een 'persoonsvorm' is.",
	    pageExists: true
	  },
	  "1b": {
	    description: "Ik kan de persoonsvorm enkelvoud en meervoud herkennen.",
	    pageExists: true
	  },
	  "1c": {
	    description: "Ik kan de persoonsvorm enkelvoud en meervoud vertalen.",
	    pageExists: true
	  },
	  "1d": {
	    description: "Ik kan uitleggen wat een 'infinitivus' is.",
	    pageExists: true
	  },
	  "1e": { description: "Ik kan de infinitivus herkennen.", pageExists: true },
	  "1f": { description: "Ik kan de infinitivus vertalen.", pageExists: true },
	  "1g": {
	    description: "Ik kan de vormen van esse herkennen en vertalen.",
	    pageExists: true
	  },
	  "1h": {
	    description: "Ik kan uitleggen wat een 'zelfstandig naamwoord' is.",
	    pageExists: true
	  },
	  "1i": {
	    description: "Ik kan uitleggen wat een 'onderwerp' is.",
	    pageExists: true
	  },
	  "1j": {
	    description: "Ik kan uitleggen wat een 'lijdend voorwerp' is.",
	    pageExists: true
	  },
	  "1k": {
	    description: "Ik kan uitleggen wat een 'naamval' is.",
	    pageExists: true
	  },
	  "1l": {
	    description: "Ik kan uitleggen welke functie de nominativus heeft.",
	    pageExists: true
	  },
	  "1m": {
	    description: "Ik kan uitleggen welke functie de accusativus heeft.",
	    pageExists: true
	  },
	  "1n": {
	    description: "Ik kan een zelfstandig naamwoord als nominativus vertalen.",
	    pageExists: true
	  },
	  "1o": {
	    description: "Ik kan een zelfstandig naamwoord als accusativus vertalen.",
	    pageExists: true
	  },
	  "1p": {
	    description: "Ik kan uitleggen wat 'getal' inhoudt.",
	    pageExists: true
	  },
	  "1q": {
	    description: "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "1r": {
	    description: "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "1s": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "1t": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "2a": {
	    description: "Ik kan uitleggen wat een 'meewerkend voorwerp' is.",
	    pageExists: true
	  },
	  "2b": {
	    description: "Ik kan uitleggen welke functie de dativus heeft.",
	    pageExists: true
	  },
	  "2c": {
	    description: "Ik kan aan de hand van de persoonsvorm in een zin voorspellen welke naamvallen ik verwacht.",
	    pageExists: true
	  },
	  "2d": {
	    description: "Ik kan een zelfstandig naamwoord als dativus vertalen.",
	    pageExists: true
	  },
	  "2e": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "2f": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "2g": {
	    description: "Ik kan uitleggen wat een 'persoonlijk voornaamwoord' is.",
	    pageExists: true
	  },
	  "2h": {
	    description: "Ik kan de persoonlijke voornaamwoorden benoemen.",
	    pageExists: true
	  },
	  "2i": {
	    description: "Ik kan de persoonlijke voornaamwoorden vertalen.",
	    pageExists: false
	  },
	  "3a": {
	    description: "Ik kan uitleggen wat een 'bijwoord' is.",
	    pageExists: true
	  },
	  "3b": {
	    description: "Ik kan uitleggen wat een 'bijwoordelijke bepaling' is.",
	    pageExists: true
	  },
	  "3c": {
	    description: "Ik kan uitleggen welke functies de ablativus heeft.",
	    pageExists: true
	  },
	  "3d": {
	    description: "Ik kan een zelfstandig naamwoord als ablativus vertalen.",
	    pageExists: true
	  },
	  "3e": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "3f": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "3g": {
	    description: "Ik kan uitleggen wat een 'voorzetsel' is.",
	    pageExists: true
	  },
	  "3h": {
	    description: "Ik kan uitleggen welke naamvallen bij een voorzetsel gebruikt kunnen worden.",
	    pageExists: true
	  },
	  "4a": {
	    description: "Ik kan uitleggen wat een 'bijvoeglijke bepaling' is.",
	    pageExists: true
	  },
	  "4b": {
	    description: "Ik kan uitleggen welke functie de genitivus heeft.",
	    pageExists: true
	  },
	  "4c": {
	    description: "Ik kan een zelfstandig naamwoord als genitivus vertalen.",
	    pageExists: true
	  },
	  "4d": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "4e": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "5a": {
	    description: "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "5b": {
	    description: "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "5c": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "5d": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "6a": {
	    description: "Ik kan voor een werkwoord bepalen welke aanvullingen ik erbij verwacht. ",
	    pageExists: false
	  },
	  "6b": {
	    description: "Ik kan uitleggen wat een 'naamwoordelijk deel van het gezegde' is.",
	    pageExists: false
	  },
	  "6c": {
	    description: "Ik kan uitleggen wat een 'kernzin' is.",
	    pageExists: false
	  },
	  "6d": {
	    description: "Ik kan het verschil tussen 'verplicht' en 'niet-verplicht' gebruik van een naamval uitleggen.",
	    pageExists: false
	  },
	  "6e": {
	    description: "Ik kan uitleggen wat de functies van elke naamval zijn.",
	    pageExists: false
	  },
	  "8a": {
	    description: "Ik kan de persoonsuitgangen herkennen.",
	    pageExists: true
	  },
	  "8b": {
	    description: "Ik kan uitleggen hoe de praesensstam wordt gevormd.",
	    pageExists: true
	  },
	  "8c": {
	    description: "Ik kan voor een werkwoord bepalen in welke stamgroep het hoort.",
	    pageExists: true
	  },
	  "8d": {
	    description: "Ik kan uitleggen wat een 'bindvocaal' is.",
	    pageExists: false
	  },
	  "8e": {
	    description: "Ik kan in een werkwoordsvorm de stam, bindvocaal en persoonsuitgang aangeven.",
	    pageExists: false
	  },
	  "8f": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "8g": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "9a": {
	    description: "Ik kan de vormen van esse en posse benoemen.",
	    pageExists: false
	  },
	  "9b": {
	    description: "Ik kan de vormen van esse en posse vertalen.",
	    pageExists: false
	  },
	  "9c": {
	    description: "Ik kan uitleggen wat een 'imperativus' is.",
	    pageExists: false
	  },
	  "9d": {
	    description: "Ik kan vormen in de imperativus benoemen.",
	    pageExists: false
	  },
	  "9e": {
	    description: "Ik kan vormen in de imperativus vertalen.",
	    pageExists: false
	  },
	  "9f": {
	    description: "Ik kan uitleggen wat een 'vocativus' is.",
	    pageExists: false
	  },
	  "9g": {
	    description: "Ik kan vormen in de vocativus benoemen.",
	    pageExists: false
	  },
	  "9h": {
	    description: "Ik kan vormen in de vocativus vertalen.",
	    pageExists: false
	  },
	  "10a": {
	    description: "Ik kan uitleggen wat het 'praesens' is.",
	    pageExists: false
	  },
	  "10b": {
	    description: "Ik kan uitleggen wat het 'imperfectum' is.",
	    pageExists: false
	  },
	  "10c": {
	    description: "Ik kan uitleggen wat het 'perfectum' is.",
	    pageExists: false
	  },
	  "10d": {
	    description: "Ik kan uitleggen wat het verschil qua gebruik is tussen het imperfectum en het perfectum.",
	    pageExists: false
	  },
	  "10e": {
	    description: "Ik kan uitleggen wat 'kenletters' zijn.",
	    pageExists: true
	  },
	  "10f": {
	    description: "Ik kan de kenletters van het imperfectum herkennen.",
	    pageExists: true
	  },
	  "10g": {
	    description: "Ik kan de persoonsuitgangen van het perfectum herkennen.",
	    pageExists: true
	  },
	  "10h": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "10i": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "10j": {
	    description: "Ik kan de vormen van esse en posse benoemen.",
	    pageExists: false
	  },
	  "10k": {
	    description: "Ik kan de vormen van esse en posse vertalen.",
	    pageExists: false
	  },
	  "11a": {
	    description: "Ik kan uitleggen wat het 'plusquamperfectum' is.",
	    pageExists: false
	  },
	  "11b": {
	    description: "Ik kan de kenletters van het plusquamperfectum herkennen.",
	    pageExists: true
	  },
	  "11c": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "11d": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "12a": {
	    description: "Ik kan uitleggen waarvoor de praesensstam wordt gebruikt.",
	    pageExists: false
	  },
	  "12b": {
	    description: "Ik kan uitleggen waarvoor de perfectumstam wordt gebruikt.",
	    pageExists: false
	  },
	  "12c": {
	    description: "Ik kan uitleggen hoe de perfectumstam wordt gevormd",
	    pageExists: true
	  },
	  "12d": {
	    description: "Ik kan in een werkwoordsvorm de stam, kenletters, bindvocalen en persoonsuitgang aangeven.",
	    pageExists: false
	  },
	  "12e": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "12f": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "15a": {
	    description: "Ik kan op basis van de woordenlijstvorm het geslacht van een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "15b": {
	    description: "Ik kan uitleggen wat een 'bijvoeglijk naamwoord' is.",
	    pageExists: true
	  },
	  "15c": {
	    description: "Ik kan uitleggen wat 'congruentie' is.",
	    pageExists: true
	  },
	  "15d": {
	    description: "Ik kan op basis van de woordenlijstvorm de stam van een bijvoeglijk naamwoord bepalen.",
	    pageExists: true
	  },
	  "15e": {
	    description: "Ik kan bijvoeglijke naamwoorden benoemen.",
	    pageExists: true
	  },
	  "15f": {
	    description: "Ik kan combinaties van een zelfstandig en bijvoeglijk naamwoord benoemen.",
	    pageExists: true
	  },
	  "16a": {
	    description: "Ik kan op basis van de woordenlijstvorm het rijtje voor een bijvoeglijk naamwoord bepalen.",
	    pageExists: true
	  },
	  "16b": {
	    description: "Ik kan op basis van de woordenlijstvorm de stam voor een bijvoeglijk naamwoord bepalen.",
	    pageExists: true
	  },
	  "16c": {
	    description: "Ik kan bijvoeglijke naamwoorden benoemen.",
	    pageExists: true
	  },
	  "16d": {
	    description: "Ik kan bepalen met welk zelfstandig naamwoord een bijvoeglijk naamwoord congrueert.",
	    pageExists: true
	  },
	  "17a": { description: "Ik kan een bijwoord herkennen.", pageExists: true },
	  "17b": { description: "Ik kan een bijwoord vertalen.", pageExists: true },
	  "18a": {
	    description: "Ik kan uitleggen wat de trappen van vergelijking zijn.",
	    pageExists: true
	  },
	  "18b": {
	    description: "Ik kan uitleggen wat een 'comparativus' is.",
	    pageExists: true
	  },
	  "18c": {
	    description: "Ik kan uitleggen hoe de comparativus wordt gevormd.",
	    pageExists: true
	  },
	  "18d": {
	    description: "Ik kan vormen in de comparativus benoemen.",
	    pageExists: true
	  },
	  "18e": {
	    description: "Ik kan uitleggen op welke manieren een comparativus vertaald kan worden.",
	    pageExists: true
	  },
	  "18f": {
	    description: "Ik kan uitleggen wat een 'superlativus' is.",
	    pageExists: true
	  },
	  "18g": {
	    description: "Ik kan uitleggen hoe de superlativus wordt gevormd.",
	    pageExists: true
	  },
	  "18h": {
	    description: "Ik kan vormen in de superlativus benoemen.",
	    pageExists: true
	  },
	  "18i": {
	    description: "Ik kan uitleggen op welke manieren een superlativus vertaald kan worden.",
	    pageExists: true
	  },
	  "18j": {
	    description: "Ik kan de onregelmatige trappen van vergelijking vertalen.",
	    pageExists: true
	  },
	  "22a": {
	    description: "Ik kan vraagwoorden en vragende bijwoorden vertalen.",
	    pageExists: true
	  },
	  "22b": {
	    description: "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
	    pageExists: true
	  },
	  "22c": {
	    description: "Ik kan zelfstandig gebruikte vragende voornaamwoorden benoemen.",
	    pageExists: true
	  },
	  "22d": {
	    description: "Ik kan zelfstandig gebruikte vragende voornaamwoorden vertalen.",
	    pageExists: true
	  },
	  "22e": {
	    description: "Ik kan bijvoeglijk gebruikte vragende voornaamwoorden benoemen.",
	    pageExists: true
	  },
	  "22f": {
	    description: "Ik kan bijvoeglijk gebruikte vragende voornaamwoorden vertalen.",
	    pageExists: true
	  },
	  "23a": {
	    description: "Ik kan uitleggen wat een 'samengestelde zin' is.",
	    pageExists: true
	  },
	  "23b": {
	    description: "Ik kan uitleggen wat een 'hoofdzin' is.",
	    pageExists: true
	  },
	  "23c": {
	    description: "Ik kan nevenschikkende voegwoorden herkennen.",
	    pageExists: true
	  },
	  "23d": {
	    description: "Ik kan uitleggen wat een 'bijzin' is.",
	    pageExists: true
	  },
	  "23e": {
	    description: "Ik kan onderschikkende voegwoorden herkennen.",
	    pageExists: true
	  },
	  "23f": {
	    description: "Ik kan een samengestelde zin opdelen in losse deelzinnen.",
	    pageExists: true
	  },
	  "24a": {
	    description: "Ik kan uitleggen wat een 'betrekkelijke bijzin' is.",
	    pageExists: true
	  },
	  "24b": {
	    description: "Ik kan uitleggen wat een 'betrekkelijk voornaamwoord' is.",
	    pageExists: true
	  },
	  "24c": {
	    description: "Ik kan uitleggen wat een 'antecedent' is.",
	    pageExists: true
	  },
	  "24d": {
	    description: "Ik kan betrekkelijke voornaamwoorden benoemen.",
	    pageExists: true
	  },
	  "24e": {
	    description: "Ik kan het antecedent van een betrekkelijke bijzin aangeven.",
	    pageExists: false
	  },
	  "24f": {
	    description: "Ik kan in een zin de betrekkelijke bijzin aangeven.",
	    pageExists: false
	  },
	  "24g": {
	    description: "Ik kan in een zin de betrekkelijke bijzin vertalen.",
	    pageExists: false
	  },
	  "25a": {
	    description: "Ik kan het verschil tussen 'directe rede' en 'indirecte rede' uitleggen.",
	    pageExists: true
	  },
	  "25b": {
	    description: "Ik kan uitleggen wat een 'aci' is.",
	    pageExists: true
	  },
	  "25c": {
	    description: "Ik kan uitleggen in welke omstandigheden je een aci in de zin verwacht.",
	    pageExists: true
	  },
	  "25d": {
	    description: "Ik kan in een zin de aci aangeven.",
	    pageExists: true
	  },
	  "25e": {
	    description: "Ik kan uitleggen wat 'gelijktijdig vertalen' inhoudt.",
	    pageExists: true
	  },
	  "25f": { description: "Ik kan een aci vertalen.", pageExists: true },
	  "25g": {
	    description: "Ik kan persoonlijke voornaamwoorden binnen een aci vertalen.",
	    pageExists: false
	  },
	  "26a": {
	    description: "Ik kan uitleggen hoe het infinitivus perfectum wordt gevormd.",
	    pageExists: false
	  },
	  "26b": {
	    description: "Ik kan een losse infinitivus perfectum vertalen.",
	    pageExists: false
	  },
	  "26c": {
	    description: "Ik kan uitleggen wat 'voortijdig vertalen' inhoudt.",
	    pageExists: true
	  },
	  "26d": { description: "Ik kan een aci vertalen.", pageExists: true },
	  "29a": {
	    description: "Ik kan uitleggen waarvoor de praesensstam wordt gebruikt.",
	    pageExists: false
	  },
	  "29b": {
	    description: "Ik kan uitleggen waarvoor de perfectumstam wordt gebruikt.",
	    pageExists: false
	  },
	  "29c": {
	    description: "Ik kan de kenletters van het futurum herkennen.",
	    pageExists: true
	  },
	  "29d": {
	    description: "Ik kan de kenletters van het futurum exactum herkennen.",
	    pageExists: true
	  },
	  "29e": {
	    description: "Ik kan in een werkwoordsvorm de stam, kenletters, bindvocalen en persoonsuitgang aangeven.",
	    pageExists: false
	  },
	  "29f": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "29g": { description: "Ik kan werkwoorden vertalen.", pageExists: true },
	  "29h": {
	    description: "Ik kan de vormen van esse en posse benoemen.",
	    pageExists: false
	  },
	  "29i": {
	    description: "Ik kan de vormen van esse en posse vertalen.",
	    pageExists: false
	  },
	  "30a": {
	    description: "Ik kan de verschillen uitleggen tussen een actieve en een passieve zin.",
	    pageExists: false
	  },
	  "30b": {
	    description: "Ik kan de persoonsuitgangen van het passivum herkennen.",
	    pageExists: true
	  },
	  "30c": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "30d": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "30e": {
	    description: "Ik kan uitleggen op welke twee manieren de handelende persoon wordt aangegeven.",
	    pageExists: false
	  },
	  "31a": {
	    description: "Ik kan uitleggen hoe het ppp wordt gevormd.",
	    pageExists: true
	  },
	  "31b": {
	    description: "Ik kan vormen van het ppp benoemen.",
	    pageExists: false
	  },
	  "31c": { description: "Ik kan een los ppp vertalen.", pageExists: false },
	  "31d": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "31e": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "32a": {
	    description: "Ik kan de onregelmatige vormen van velle, nolle en malle benoemen.",
	    pageExists: false
	  },
	  "32b": {
	    description: "Ik kan de onregelmatige vormen van velle, nolle en malle vertalen.",
	    pageExists: false
	  },
	  "32c": {
	    description: "Ik kan de onregelmatige vormen van ferre en ire benoemen.",
	    pageExists: false
	  },
	  "32d": {
	    description: "Ik kan de onregelmatige vormen van ferre en ire vertalen.",
	    pageExists: false
	  },
	  "32e": {
	    description: "Ik kan samengestelde vormen van ferre en ire benoemen.",
	    pageExists: false
	  },
	  "32f": {
	    description: "Ik kan samengestelde vormen van ferre en ire vertalen.",
	    pageExists: false
	  },
	  "33a": {
	    description: "Ik kan uitleggen hoe de infinitivus praesens passief wordt gevormd.",
	    pageExists: true
	  },
	  "33b": {
	    description: "Ik kan een losse infinitivus praesens passief vertalen.",
	    pageExists: true
	  },
	  "33c": {
	    description: "Ik kan uitleggen hoe de infinitivus perfectum passief wordt gevormd.",
	    pageExists: true
	  },
	  "33d": {
	    description: "Ik kan een losse infinitivus perfectum passief vertalen.",
	    pageExists: true
	  },
	  "33e": {
	    description: "Ik kan uitleggen hoe het pfa wordt gevormd.",
	    pageExists: true
	  },
	  "33f": {
	    description: "Ik kan uitleggen hoe de infinitivus futurum actief wordt gevormd.",
	    pageExists: true
	  },
	  "33g": {
	    description: "Ik kan een losse infinitivus futurum actief vertalen.",
	    pageExists: true
	  },
	  "33h": {
	    description: "Ik kan uitleggen wat 'natijdig vertalen' inhoudt.",
	    pageExists: true
	  },
	  "33i": { description: "Ik kan een aci vertalen.", pageExists: true },
	  "36a": {
	    description: "Ik kan op basis van de woordenlijstvorm het rijtje voor een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "36b": {
	    description: "Ik kan op basis van de woordenlijstvorm de stam van een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "36c": {
	    description: "Ik kan op basis van de woordenlijstvorm het geslacht van een zelfstandig naamwoord bepalen.",
	    pageExists: true
	  },
	  "36d": {
	    description: "Ik kan zelfstandige naamwoorden benoemen.",
	    pageExists: true
	  },
	  "36e": {
	    description: "Ik kan zelfstandige naamwoorden vertalen.",
	    pageExists: false
	  },
	  "37a": {
	    description: "Ik kan uitleggen wat een 'dubbelverbonden bepaling' is.",
	    pageExists: true
	  },
	  "37b": {
	    description: "Ik kan een bijvoeglijk naamwoord bijvoeglijk vertalen.",
	    pageExists: true
	  },
	  "37c": {
	    description: "Ik kan een bijvoeglijk naamwoord dubbelverbonden vertalen.",
	    pageExists: true
	  },
	  "37d": {
	    description: "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
	    pageExists: true
	  },
	  "37e": {
	    description: "Ik kan een bijvoeglijk naamwoord zelfstandig vertalen.",
	    pageExists: true
	  },
	  "38a": {
	    description: "Ik kan uitleggen hoe het ppa wordt gevormd.",
	    pageExists: true
	  },
	  "38b": {
	    description: "Ik kan vormen van het ppa benoemen.",
	    pageExists: true
	  },
	  "38c": { description: "Ik kan een los ppa vertalen.", pageExists: true },
	  "38d": {
	    description: "Ik kan een ppa in zinsverband vertalen.",
	    pageExists: true
	  },
	  "38e": {
	    description: "Ik kan uitleggen wat 'gelijktijdig vertalen' inhoudt.",
	    pageExists: true
	  },
	  "38f": {
	    description: "Ik kan in een zin de participiumwoordgroep aangeven.",
	    pageExists: true
	  },
	  "38g": {
	    description: "Ik kan een ppa binnen een participiumwoordgroep vertalen.",
	    pageExists: false
	  },
	  "39a": {
	    description: "Ik kan uitleggen wat 'voortijdig vertalen' inhoudt.",
	    pageExists: false
	  },
	  "39b": {
	    description: "Ik kan het verschil in vertaling tussen een ppa en een ppp uitleggen.",
	    pageExists: true
	  },
	  "39c": {
	    description: "Ik kan participia binnen een participiumwoordgroep vertalen.",
	    pageExists: true
	  },
	  "40a": {
	    description: "Ik kan uitleggen wat een 'aanwijzend voornaamwoord' is.",
	    pageExists: false
	  },
	  "40b": {
	    description: "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
	    pageExists: false
	  },
	  "40c": {
	    description: "Ik kan vormen van het aanwijzend voornaamwoord benoemen.",
	    pageExists: false
	  },
	  "40d": {
	    description: "Ik kan vormen van het aanwijzend voornaamwoord bijvoeglijk vertalen.",
	    pageExists: false
	  },
	  "40e": {
	    description: "Ik kan vormen van het aanwijzend voornaamwoord zelfstandig vertalen.",
	    pageExists: false
	  },
	  "40f": {
	    description: "Ik kan het verschil in betekenis tussen ille en iste uitleggen.",
	    pageExists: false
	  },
	  "40g": {
	    description: "Ik kan vormen van het verwijzend voornaamwoord benoemen.",
	    pageExists: false
	  },
	  "40h": {
	    description: "Ik kan vormen van het verwijzend voornaamwoord bijvoeglijk vertalen.",
	    pageExists: false
	  },
	  "40i": {
	    description: "Ik kan vormen van het verwijzend voornaamwoord zelfstandig vertalen.",
	    pageExists: false
	  },
	  "40j": {
	    description: "Ik kan vormen van het bepalend voornaamwoord benoemen.",
	    pageExists: false
	  },
	  "40k": {
	    description: "Ik kan vormen van het bepalend voornaamwoord vertalen.",
	    pageExists: false
	  },
	  "43a": {
	    description: "Ik kan de kenletters van de conjunctivus praesens herkennen.",
	    pageExists: false
	  },
	  "43b": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "43c": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "43d": {
	    description: "Ik kan de vormen van esse en posse benoemen.",
	    pageExists: false
	  },
	  "43e": {
	    description: "Ik kan de vormen van esse en posse vertalen.",
	    pageExists: false
	  },
	  "43f": {
	    description: "Ik kan uitleggen op welke zes manieren een conjunctivus praesens in de hoofdzin kan worden vertaald.",
	    pageExists: false
	  },
	  "43g": {
	    description: "Ik kan in een zin de meest passende vertaling van de conjunctivus praesens bepalen.",
	    pageExists: false
	  },
	  "44a": {
	    description: "Ik kan de kenletters van de conjunctivus imperfectum herkennen.",
	    pageExists: false
	  },
	  "44b": {
	    description: "Ik kan de kenletters van de conjunctivus perfectum actief herkennen.",
	    pageExists: false
	  },
	  "44c": {
	    description: "Ik kan de kenletters van de conjunctivus plusquamperfectum actief herkennen.",
	    pageExists: false
	  },
	  "44d": { description: "Ik kan werkwoorden benoemen.", pageExists: false },
	  "44e": { description: "Ik kan werkwoorden vertalen.", pageExists: false },
	  "44f": {
	    description: "Ik kan de vormen van esse en posse benoemen.",
	    pageExists: false
	  },
	  "44g": {
	    description: "Ik kan de vormen van esse en posse vertalen.",
	    pageExists: false
	  },
	  "44h": {
	    description: "Ik kan het verschil tussen een 'verplichte' en 'niet-verplichte' conjunctivus uitleggen.",
	    pageExists: false
	  },
	  "44i": {
	    description: "Ik kan het verschil tussen een 'directe vraag' en een 'indirecte vraag' uitleggen.",
	    pageExists: false
	  },
	  "44j": {
	    description: "Ik kan een indirecte vraag herkennen.",
	    pageExists: false
	  },
	  "44k": {
	    description: "Ik kan een conjunctivus in een indirecte vraag vertalen.",
	    pageExists: false
	  },
	  "44l": {
	    description: "Ik kan uitleggen hoe de vertaling van cum en ut wordt beïnvloed door de persoonsvorm die erbij hoort.",
	    pageExists: false
	  },
	  "44m": {
	    description: "Ik kan cum, ut en ne in combinatie met een conjunctivus vertalen.",
	    pageExists: false
	  },
	  "45a": {
	    description: "Ik kan uitleggen wat een 'irrealis' is.",
	    pageExists: false
	  },
	  "45b": {
	    description: "Ik kan een conjunctivus irrealis herkennen.",
	    pageExists: false
	  },
	  "45c": {
	    description: "Ik kan bij een irrealis aangeven of het betrekking heeft op het heden of het verleden.",
	    pageExists: false
	  },
	  "45d": {
	    description: "Ik kan een conjunctivus irrealis vertalen.",
	    pageExists: false
	  },
	  "45e": {
	    description: "Ik kan uitleggen hoe een conjunctivus in een betrekkelijke bijzin vertaald moet worden.",
	    pageExists: false
	  },
	  "45f": {
	    description: "Ik kan een conjunctivus in een betrekkelijke bijzin vertalen.",
	    pageExists: false
	  },
	  "45g": {
	    description: "Ik kan bij een conjunctivusvorm aangeven hoe deze is gebruikt.",
	    pageExists: false
	  },
	  "46a": {
	    description: "Ik kan uitleggen wat een 'onbepaald voornaamwoord' is.",
	    pageExists: false
	  },
	  "46b": {
	    description: "Ik kan onbepaalde voornaamwoorden benoemen.",
	    pageExists: false
	  },
	  "46c": {
	    description: "Ik kan het verschil tussen 'zelfstandig gebruik' en 'bijvoeglijk gebruik' uitleggen.",
	    pageExists: false
	  },
	  "46d": {
	    description: "Ik kan onbepaalde voornaamwoorden zelfstandig vertalen.",
	    pageExists: false
	  },
	  "46e": {
	    description: "Ik kan onbepaalde voornaamwoorden bijvoeglijk vertalen.",
	    pageExists: false
	  },
	  "50a": {
	    description: "Ik kan uitleggen wat een 'deponens' is.",
	    pageExists: false
	  },
	  "50b": {
	    description: "Ik kan op basis van de woordenlijstvorm bepalen of een werkwoord een deponens is.",
	    pageExists: false
	  },
	  "50c": { description: "Ik kan deponensvormen vertalen.", pageExists: false },
	  "50d": {
	    description: "Ik kan uitleggen wat een 'semi-deponens' is.",
	    pageExists: false
	  },
	  "50e": {
	    description: "Ik kan semi-deponensvormen vertalen.",
	    pageExists: false
	  },
	  "51a": {
	    description: "Ik kan uitleggen hoe het ppp van een deponens vertaald moet worden.",
	    pageExists: false
	  },
	  "51b": {
	    description: "Ik kan participia binnen een participiumwoordgroep vertalen.",
	    pageExists: false
	  },
	  "52a": {
	    description: "Ik kan uitleggen wat een 'ablativus absolutus' is.",
	    pageExists: false
	  },
	  "52b": {
	    description: "Ik kan in een zin de ablativus absolutus aangeven.",
	    pageExists: false
	  },
	  "52c": {
	    description: "Ik kan een ablativus absolutus met een ppa vertalen.",
	    pageExists: false
	  },
	  "52d": {
	    description: "Ik kan een ablativus absolutus met een ppp vertalen.",
	    pageExists: false
	  },
	  "54a": {
	    description: "Ik kan uitleggen wat een 'gerundium' is.",
	    pageExists: false
	  },
	  "54b": {
	    description: "Ik kan vormen van het gerundium benoemen.",
	    pageExists: false
	  },
	  "54c": {
	    description: "Ik kan in een zin de gerundiumwoordgroep aangeven.",
	    pageExists: false
	  },
	  "54d": {
	    description: "Ik kan een gerundium(woordgroep) vertalen.",
	    pageExists: false
	  },
	  "54e": {
	    description: "Ik kan uitleggen wat een 'gerundivum' is.",
	    pageExists: false
	  },
	  "54f": {
	    description: "Ik kan uitleggen wat het verschil is tussen een gerundium en gerundivum.",
	    pageExists: false
	  },
	  "54g": {
	    description: "Ik kan vormen van het gerundivum benoemen.",
	    pageExists: false
	  },
	  "54h": {
	    description: "Ik kan een gerundivum zonder esse vertalen.",
	    pageExists: false
	  },
	  "54i": {
	    description: "Ik kan een gerundivum van verplichting (met esse) vertalen.",
	    pageExists: false
	  },
	  "54j": {
	    description: "Ik kan uitleggen hoe de handelende persoon bij een gerundivum van verplichting wordt aangegeven.",
	    pageExists: false
	  }
	};
	module.exports = exports["default"];

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  table {\n    font-size: 0.9em;\n    line-height: 100%;\n    margin-bottom: 10px;\n    margin-left: 2.4375em;\n    width: 1%; /* auto-width for cells */\n    white-space: nowrap; /* auto-width for cells */\n\n    > tbody {\n      > tr {\n        > td {\n          padding: 0px 1.875em 0.5em 0px;\n        }\n      }\n    }\n  }\n"], ["\n  table {\n    font-size: 0.9em;\n    line-height: 100%;\n    margin-bottom: 10px;\n    margin-left: 2.4375em;\n    width: 1%; /* auto-width for cells */\n    white-space: nowrap; /* auto-width for cells */\n\n    > tbody {\n      > tr {\n        > td {\n          padding: 0px 1.875em 0.5em 0px;\n        }\n      }\n    }\n  }\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _rehypeReact = __webpack_require__(187);
	
	var _rehypeReact2 = _interopRequireDefault(_rehypeReact);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Helmet = __webpack_require__(72);
	
	var _Helmet2 = _interopRequireDefault(_Helmet);
	
	var _Leerdoel = __webpack_require__(640);
	
	var _Leerdoel2 = _interopRequireDefault(_Leerdoel);
	
	var _Leerdoelen = __webpack_require__(224);
	
	var _Leerdoelen2 = _interopRequireDefault(_Leerdoelen);
	
	var _Letop = __webpack_require__(7);
	
	var _Letop2 = _interopRequireDefault(_Letop);
	
	var _ExtraTip = __webpack_require__(191);
	
	var _ExtraTip2 = _interopRequireDefault(_ExtraTip);
	
	var _Tip = __webpack_require__(26);
	
	var _Tip2 = _interopRequireDefault(_Tip);
	
	var _Wrapper = __webpack_require__(192);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var renderAst = new _rehypeReact2.default({
	  createElement: _react2.default.createElement,
	  components: {
	    letop: _Letop2.default,
	    t: _Tip2.default,
	    x: _ExtraTip2.default
	  }
	}).Compiler;
	
	var Title = _styledComponents2.default.h1(_templateObject);
	
	var Post = _styledComponents2.default.div(_templateObject2);
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  var _post$frontmatter = post.frontmatter,
	      book = _post$frontmatter.book,
	      leerdoel = _post$frontmatter.leerdoel,
	      title = _post$frontmatter.title;
	
	  return _react2.default.createElement(
	    _Wrapper2.default,
	    null,
	    _react2.default.createElement(_Helmet2.default, { data: data }),
	    _react2.default.createElement(
	      Title,
	      null,
	      title
	    ),
	    _react2.default.createElement(_Leerdoel2.default, { book: book, leerdoel: leerdoel }),
	    _react2.default.createElement(
	      Post,
	      null,
	      renderAst(post.htmlAst)
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-leerdoel-js-ef7a740cba8f330fa843.js